import {
  getLockPin,
  GetLockPinQuery,
  GetLockPinQueryVariables,
  graphqlCall,
} from '@akin-home/amplify';

interface Params {
  user_id?: string;
}

export const checkHasLockPIN = async ({
  user_id,
}: Params): Promise<boolean> => {
  if (!user_id) return false;

  const res = await graphqlCall<GetLockPinQuery, GetLockPinQueryVariables>(
    getLockPin,
    { user_id }
  );

  return !!res.data.getLockPin;
};
